/**
 * @file staffNoContent.ts
 * @brief VERBLIZR staff never read user content (B2/W4, DES 22-10-2026).
 *
 * @details
 * A content route that refuses a staff role answers 403
 * `{ code: "STAFF_NO_CONTENT" }`; the page shows a calm private state for it
 * (components/feedback/StaffNoContent), never an error toast.
 *
 * @author DES
 * @date 22-10-2026
 */

import { ApiClientError } from "./client";

export const STAFF_NO_CONTENT = "STAFF_NO_CONTENT";
export const STAFF_NO_CONTENT_LINE = "VERBLIZR staff cannot see meeting content.";

/** True for the backend's 403 `{ code: "STAFF_NO_CONTENT" }`. */
export function isStaffNoContentError(err: unknown): boolean {
  return err instanceof ApiClientError && err.code === STAFF_NO_CONTENT;
}
